import uuid from 'node-uuid';
import moment from 'moment';
import "./Tile";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");
/**
 * @class
 * @extends GIS.Map.Layer.Tile
 */
GIS.Map.Layer.Sputnik = Class(GIS.Map.Layer.Tile, /** @lends GIS.Map.Layer.Sputnik.prototype */ {
    // options
    title: "Спутник",
    projection: 'EPSG:3857',
    apiKey: null,
    attributions: ["Картографические данные © Ростелеком, " + moment().format('YYYY')],
    url: "https://tilessputnik.ru/{z}/{x}/{y}.png?apiKey={apiKey}",
    maxZoom: 18,
    minZoom: 1,
    /**
     * @type {string[]}
     * @protected
     */
    urlParams: ["apiKey"],
    /** @inheritDoc */
    initialize() {
        this.ParentCall();
        this.name = "GIS.Map.Layer.Sputnik:" + uuid.v4();
    },
    /** @inheritDoc */
    optionsNames() {
        return this.ParentCall().concat(["apiKey"]);
    }
});
